import Hotjar from '@hotjar/browser';
import useAuthUser from './hooks/useAuthUser';

function HotjarProvider() {
  const authUser = useAuthUser();

  const userRole = authUser?.role;
  if (userRole === 'admin' || userRole === 'manager') return null;

  const siteId = +(import.meta.env.VITE_APP_API_HOTJARID || '0');
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);

  return null;
}

export default HotjarProvider;
